import { render, staticRenderFns } from "./yandex_general_tab.vue?vue&type=template&id=7f051f13&scoped=true&"
import script from "./yandex_general_tab.vue?vue&type=script&lang=js&"
export * from "./yandex_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f051f13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f051f13')) {
      api.createRecord('7f051f13', component.options)
    } else {
      api.reload('7f051f13', component.options)
    }
    module.hot.accept("./yandex_general_tab.vue?vue&type=template&id=7f051f13&scoped=true&", function () {
      api.rerender('7f051f13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/yandex/location/tabs/yandex_general_tab.vue"
export default component.exports